/** Open box mark. The top edge stays open. */
export default function Mark({ size = 25 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 26 26" fill="none" aria-hidden="true">
      <path d="M4 9.5 L4 21 L22 21 L22 9.5" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
      <path d="M4 9.5 L13 5 L22 9.5" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
      <path d="M4 9.5 L13 14 L22 9.5" stroke="var(--accent)" strokeWidth="1" strokeLinejoin="round" strokeLinecap="round" />
      <path d="M13 14 L13 21.6" stroke="var(--accent)" strokeWidth="1" strokeLinecap="round" />
    </svg>
  )
}
